module.exports = __webpack_public_path__ + "img/file-upload-regular.e3da6912.svg";